import { render, staticRenderFns } from "./LabBaseFirebaseAndMinioComposition.vue?vue&type=template&id=4b48133f&"
import script from "./LabBaseFirebaseAndMinioComposition.vue?vue&type=script&lang=js&"
export * from "./LabBaseFirebaseAndMinioComposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports